module.exports = __webpack_public_path__ + "img/P1070885.21a349f9.jpg";